import { format } from "date-fns";
import { FetchParams } from "../hooks/utility-hoks/useFetchWithToken";
import { RokaState } from "../types/rokaTypes";

type GetStateResponseBody = {
  name: string;
  reset_time: Date;
};

export type GetStateResponse = {
  statusCode: number;
  body: GetStateResponseBody;
};

export const getUserState = (): FetchParams => ({
  url: "https://api.rmcounting.no/v3/state/user",
});

export const setUserState = (state: RokaState): FetchParams => ({
  url: "https://api.rmcounting.no/v3/state/user",
  options: {
    method: "POST",
    body: JSON.stringify({
      reset_time: format(state.resetTime, "yyyy-MM-dd'T'HH:mm"),
    }),
  },
});
